import { useTranslation } from 'react-i18next';
import {
  ButtonGroup,
  HorizontalNavigation,
  NavigationUserControls,
} from '@hawkins/components';

import classes from './Header.module.css';
import { HomeLogo } from './HomeLogo';
import { LanguageSelector } from './LanguageSelector';

export function SignedInHeader(): JSX.Element {
  const { i18n } = useTranslation();

  const handleLanguageSelection = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <HorizontalNavigation className={classes.signedHeader}
      logo={<HomeLogo />}
      transparent={false}
      userControls={
        <NavigationUserControls actions={
          <ButtonGroup>
            <div className={classes.languageSelector}>
              <LanguageSelector
                locale={i18n.language}
                onLanguageSelected={(loc) => handleLanguageSelection(loc)}
              />
            </div>
          </ButtonGroup>
        }
          className={classes.userControls}
        />
      }>
    </HorizontalNavigation>
  );
}
